// error-dialog.component.ts
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  standalone: false,
	selector: 'app-error-dialog',
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div>
			<p>{{ config.data.message }}</p>
		</div>
		<div class="p-dialog-footer">
			<button pButton type="button" (click)="close()"><i class="p-button-icon pi pi-times"></i><span class="p-button-label">Close</span></button>
		</div>
	`,
})
export class ErrorDialogComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {}

	ngOnInit() {}

	close() {
		this.ref.close();
	}
}
